;(function () {
	const initCollage = () => {
		$('.image-collage-section').each(function (index, element) {
			if ($(this).hasClass('image-collage_started')) {
				return ''
			}
			$(this).addClass('image-collage_started')
			const id = $(this).attr('id')
			const box = $(this).find('.image-collage')
			const swiperContainer = document.querySelector(`#${id} .image-collage__swiper`);
			const slides = swiperContainer ? swiperContainer.querySelectorAll('.swiper-slide') : [];
			
			// Skip initialization if no valid slides
			if (!slides || slides.length === 0) return;

			const speed = box.data('speed') * 1000
			// Only enable loop if we have enough slides (more than max visible)
			const enableLoop = slides.length > 4;

			new Swiper(`#${id} .image-collage__swiper`, {
				centeredSlides: true,
				loop: enableLoop,
				speed: speed,
				allowTouchMove: false,
				autoplay: enableLoop ? {
					delay: 0,
					disableOnInteraction: false,
					pauseOnMouseEnter: false,
				} : false,
				breakpoints: {
					320: {
						slidesPerView: 2,
						spaceBetween: 8,
					},
					750: {
						slidesPerView: 3.9,
						spaceBetween: 16,
					},
				},
			})
		})
	}

	document.addEventListener('DOMContentLoaded', function () {
		initCollage()
		document.addEventListener('shopify:section:load', function () {
			initCollage()
		})
	})
})()
